const data = {
  name: '全部',
  getList: '',
  getDetail: '',
  status: null,
  columns: [
    {
      prop: 'index',
      label: '序号',
      width: '100'
    }, {
      prop: 'date',
      label: '日期',
      width: '150'
    }, {
      prop: 'name',
      label: '姓名',
      width: '120'
    }, {
      prop: 'province',
      label: '省份',
      width: '120'
    }, {
      prop: 'city',
      label: '市区',
      width: '120'
    }, {
      prop: 'address',
      label: '地址'
    }, {
      prop: 'zip',
      label: '邮编',
      width: '120'
    }, {
      fixed: 'right',
      label: '操作',
      width: '100'
    }
  ]
}

export const ratioTablesColumns = [
  {
    prop: 'index',
    label: '序号',
    width: '100'
  }, {
    prop: 'alias',
    label: '任务名称',
    width: '150'
  }, {
    prop: 'week',
    label: '执行时间',
    width: '150'
  }, {
    prop: 'siteCount',
    label: '站点数',
    width: '100'
  }, {
    prop: 'openSwitch',
    label: '任务开关',
    width: '120'
  }, {
    fixed: 'right',
    label: '操作',
    width: '100'
  }
]

export const ratioEditColumns = [
  {
    prop: 'siteName',
    label: '站点名称'
  }, {
    prop: 'ratio',
    label: '满桩值'
  }, {
    fixed: 'right',
    label: '操作',
    width: '50'
  }
]
export default data
